import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function OriginSection() {
  return <section className="py-28 px-6 bg-cream relative" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <ScrollReveal width="100%" className="mb-16 text-center" data-id="element-72">
          <span className="text-xs font-sans font-medium tracking-editorial text-slate uppercase border-b border-slate/20 pb-2 inline-block" data-id="element-73">
            The Origin
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-ink mt-8 leading-tight" data-id="element-74">
            How I Went From Homeless to Building a Hedge Fund
          </h2>
        </ScrollReveal>

        <div className="relative pl-8 md:pl-12 border-l border-slate/15" data-id="element-75">
          {/* Timeline Dots */}
          <div className="absolute -left-[4px] top-0 w-2 h-2 rounded-full bg-slate" data-id="element-76" />
          <div className="absolute -left-[4px] top-1/3 w-2 h-2 rounded-full bg-slate/40" data-id="element-77" />
          <div className="absolute -left-[4px] top-2/3 w-2 h-2 rounded-full bg-slate/40" data-id="element-78" />
          <div className="absolute -left-[4px] bottom-0 w-2 h-2 rounded-full bg-slate" data-id="element-79" />

          <div className="font-sans text-slate-dark leading-relaxed" data-id="element-80">
            <ScrollReveal delay={0.1} data-id="element-81">
              <p className="font-serif text-2xl italic text-ink mb-8" data-id="element-82">
                I know what it feels like when your business becomes a prison
                instead of a path to freedom.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.15} data-id="element-83">
              <p className="mb-6 font-light text-lg" data-id="element-84">
                Years ago, I was homeless. Not because I lacked ambition or
                intelligence. But because I was building from a fractured
                foundation. I was chasing growth the way everyone told me to…
                with force, pressure, and hustle. And it nearly destroyed me.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.2} data-id="element-85">
              <p className="mb-6 font-light text-lg" data-id="element-86">
                The strategies worked on paper. But my nervous system was
                running on fear. My decisions came from survival, not vision.
                And no amount of tactical brilliance could fix the internal
                chaos I was operating from.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.25} data-id="element-87">
              <p className="mb-6 font-light text-lg" data-id="element-88">
                I kept hitting the same wall. Revenue would spike, then crash. I
                would feel powerful one week and paralyzed the next. My body was
                screaming at me to stop, but I thought the answer was to push
                harder.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3} data-id="element-89">
              <blockquote className="font-serif italic text-3xl text-ink border-l-2 border-slate/20 pl-6 my-12" data-id="element-90">
                Then something shifted.
              </blockquote>
            </ScrollReveal>

            <ScrollReveal delay={0.35} data-id="element-91">
              <p className="mb-6 font-light text-lg" data-id="element-92">
                I realized the problem was not my strategy. It was my state. I
                was trying to build an empire on a foundation that could not
                hold it. So I stopped adding more tactics and started doing the
                deeper work. I regulated my nervous system. I recalibrated my
                identity. I aligned my internal world with the external business
                I was trying to create.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.4} data-id="element-93">
              <p className="mb-6 font-light text-lg" data-id="element-94">And everything changed.</p>
            </ScrollReveal>

            <ScrollReveal delay={0.45} data-id="element-95">
              <p className="mb-6 font-light text-lg" data-id="element-96">
                I went from homeless to becoming the General Partner of a
                cryptocurrency hedge fund. Not because I found a better funnel
                or a new marketing trick. But because I built internal coherence
                first. I became a leader who could hold power, wealth, and
                visibility without collapsing under the weight of it.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.5} data-id="element-97">
              <blockquote className="font-serif italic text-2xl md:text-3xl text-ink border-l-2 border-slate/20 pl-6 my-12" data-id="element-98">
                "That is when I created The Omnipreneur Incubator."
              </blockquote>
            </ScrollReveal>

            <ScrollReveal delay={0.55} data-id="element-99">
              <p className="mb-6 font-light text-lg" data-id="element-100">
                Because I saw too many brilliant, spiritually aware women
                trapped in the same cycle I escaped. They had built successful
                businesses, but those businesses no longer fit who they had
                become. They were exhausted, misaligned, and terrified that
                scaling would break them.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.6} data-id="element-101">
              <p className="font-light text-lg" data-id="element-102">
                This program exists because I refuse to let another woman
                sacrifice her peace for her profit. You do not need more
                strategy. You need structural realignment. And that is exactly
                what we do here.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-ink/10" data-id="element-103" />
    </section>;
}